import styles from "./SubgroupSelect.module.css";
import { NewUserProfileType } from "../Types/userProfile";

import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  addDoc,
  arrayRemove,
  collection,
  doc,
  getDoc,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { app } from "../lib/firebase";
import { NewProjectProfileType } from "../Types/projectProfile";
import {
  IteratedDataSnapshot,
  child,
  get,
  getDatabase,
  push,
  ref,
} from "firebase/database";
import AdminProfile from "./ProjectProfile";
import UpdateID from "./UpdateID";
import {
  AddGroupProfileType,
  UserField,
  ContainsGroups,
  ContainedInGroups,
} from "../Types/groupProfile";
import WelcomePage from "../WelcomePage/WelcomePage";
import { deleteProject, UpdateProjectID } from "../lib/controller";

const projectOwner = localStorage.getItem("currentGroup");

const db = getFirestore(app);
const tempUser = localStorage.getItem("userUID");
const tempUserEmail = "";
const tempUserName = "";

//function reloadPage() {
//  setTimeout(function)
//  window.location.reload();
//}

function SubgroupSelect() {
  const [currentGroup, setCurrentGroup] = useState(
    localStorage.getItem("currentGroup")
  );

  console.log("in projectSelect and user id = ", tempUser);
  console.log("in projectSelect and current group = ", currentGroup);
  const [containsProfiles, setContainsProfiles] = useState<ContainsGroups[]>(
    []
  );
  const [containedInProfiles, setContainedInProfiles] = useState<
    ContainedInGroups[]
  >([]);

  const [getSelect, setGetSelect] = useState(false);

  //const [subgroupSubprojectID, setSubgroupSubprojectID] = useState([]);
  //const [subgroupSubprojectDescription, setSubgroupSubprojectDescription] = useState([]);
  //const [subgroupSubprojectTitle, setSubgroupSubprojectTitle] = useState([]);
  //const [subgroupTitle, setSubgroupTitle] = useState([]);

  let subgroupSubprojectDescription = [];
  let subgroupSubprojectTitle = [];
  let subgroupTitle = [];

  //const [supergroupSuperprojectID, setSupergroupSuperprojectID] = useState([]);
  //const [supergroupSuperprojectTitle, setSupergroupSuperprojectTitle] = useState([]);
  //const [supergroupTitle, setSupergroupTitle] = useState([]);

  let supergroupSuperprojectTitle = [];
  let supergroupTitle = [];

  const [messages, setMessages] = useState(
    "First, select a project for which to add subgroups. Second, select a group to add to the subgroups for this project. Third, press the 'Copy Selection' button. Fourth, edit the project description and describe the duties you want the subgroup to perform. Then press the 'Save' button and the subgroup will receive the new project. You will be guided step by step..."
  );
  const [selectUsers, setSelectUsers] = useState("none");
  const [selectProjects, setSelectProjects] = useState("none");

  //Buttons
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);

  const [
    updateSubgroupProjectButtonDisabled,
    setUpdateSubgroupProjectButtonDisabled,
  ] = useState(true);
  const [
    removeFromProjectSubroupButtonDisabled,
    setRemoveFromProjectSubgroupButtonDisabled,
  ] = useState(true);

  //Projects
  const [projectProfiles, setProjectProfiles] = useState<
    NewProjectProfileType[]
  >([]);
  const [projectTitleInput, setProjectTitleInput] = useState("");
  const [projectDescriptionInput, setProjectDescriptionInput] = useState("");
  const [projectDetailedDescriptionInput, setProjectDetailedDescriptionInput] =
    useState("");

  let projectRefArray = [];
  let projectTitles = [];
  let projectDescriptions = [];
  let projectDetailedDescriptions = [];

  let groupRefArray = [];
  let affiliation = [];
  let administrator = [];
  let email = [];
  let projectID = [];

  const [groupName, setGroupName] = useState([]);
  const [subgroupName, setSubgroupName] = useState([]);

  //const [projectRefArray, setProjectRefArray] = useState([]);
  //const [groupRefArray, setGroupRefArray] = useState([]);

  const [projectDescriptionReadOnly, setProjectDescriptionReadOnly] =
    useState(false);

  //const [projectTitles, setProjectTitles] = useState([]);
  //const [projectDescriptions, setProjectDescriptions] = useState([]);
  //const [projectDetailedDescriptions, setProjectDetailedDescriptions] = useState([]);

  let tempProject: NewProjectProfileType;
  //The index into project listbox starts with 1 because of "Project Selection" text as item 0
  const [projectTitlesIndex, setProjectTitlesIndex] = useState(1);
  const [groupSelectedIndex, setGroupSelectedIndex] = useState(1);
  const [subgroupSelectIndex, setSubgroupSelectIndex] = useState(1);
  const [affiliationTitle, setAffilationTitle] = useState("");
  const [administratorTitle, setAdministratorTitle] = useState("");
  const [emailTitle, setEmailTitle] = useState("");

  //const [affiliation, setAffiliation] = useState([""]);
  //const [administrator, setAdministrator] = useState([""]);
  //const [email, setEmail] = useState([""]);
  const [groupProfiles, setGroupProfiles] = useState<AddGroupProfileType[]>([]);
  //Users
  const [userProfiles, setUserProfiles] = useState<NewUserProfileType[]>([]);
  const [allUsersField, setAllUsersField] = useState<UserField[]>([]);
  const [projectAllUsersField, setProjectAllUsersField] = useState<UserField[]>(
    []
  );

  let userRefArray: string[] = [];

  const [subgroupSelectedIndex, setSubgroupSelectedIndex] = useState(1);

  const [tempUIDArray, setTempUIDArray] = useState([]);
  const [docUserRefArray, setDocUserRefArray] = useState([]);
  const [projectUID, setProjectUID] = useState([]);
  const [userNames, setUserNames] = useState([]);
  const [userEmails, setUserEmails] = useState([]);
  const [userNamesAndEmails, setUserNamesAndEmails] = useState([]);
  let tempUserProfile: NewUserProfileType;

  var bodyStyles = document.body.style;

  const SubgroupSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    console.log("in subgroup selected...");

    if (e.currentTarget.selectedIndex == 0) {
      return;
    }

    //allProjectsFieldIndex = e.currentTarget.selectedIndex;
    setSubgroupSelectedIndex(e.currentTarget.selectedIndex - 1);

    //This has to change since we are no longer using the arrays.
    //Rather we have to go through the owning groups containsGroups and find the entry
    //which has the subgroupTitle === selected subgroup title displayed in the listbox
    //                            === subgroupName[e.currentTarget.selectedIndex - 1];
    //Then using that same containsGroups entry (index) we need to copy the
    //subgroupSubprojectDescription from containsGroup into the Subproject Description textarea
    //which is projectDescriptionInput and is set by setProjectDescriptionInput
    //Find the currentGroup index into the groupProfile array...
    let currentGroupIndex = 0;
    if (groupRefArray.length > 0) {
      for (let i = 0; i < groupProfiles.length; i++) {
        console.log("ref  = ", groupRefArray[i], "for i = ", i);
        console.log("ref title = ", groupProfiles[i].title);
        if (groupProfiles[i].title === currentGroup) {
          currentGroupIndex = i;
          console.log(" found title at index i = ", i);
          console.log("groupRefArray = ", groupRefArray);
          break;
        }
      }
      console.log(" currentGroupIndex = ", currentGroupIndex);
      //Now, use the index into the groupProfiles array and point to the containsGroups
      //and loop through the entries until one with the same title as the selected subgroup selection
      let tempTitle = "";
      let tempDescription = "";
      let found = false;
      if (groupProfiles[currentGroupIndex].containsGroups !== undefined) {
        for (
          let j = 0;
          j < groupProfiles[currentGroupIndex].containsGroups.length;
          j++
        ) {
          if (
            groupProfiles[currentGroupIndex].containsGroups[j] !== undefined
          ) {
            for (const [key, value] of Object.entries(
              groupProfiles[currentGroupIndex].containsGroups[j]
            )) {
              //retrieve the key value pairs for this entry for subgroupTitle and subgroupSubprojectDescription
              if (key === "subgroupTitle") {
                tempTitle = value;
                console.log("tempTitle");
              } else if (key === "subgroupSubprojectDescription") {
                tempDescription = value;
              }
            }
            //Are we looking at the title field and does it match the selected subgroup title?
            if (tempTitle === subgroupName[e.currentTarget.selectedIndex - 1]) {
              //Yes, so fill in the subproject description field with the description key value.
              //projectDescriptionInput.push(tempDescription as unknown as Array<string>);
              setProjectDescriptionReadOnly(true);
              setProjectDescriptionInput(tempDescription);
              //document
              //  .getElementById("input_Description")
              //  .setAttribute("value", tempDescription);
              //
              break;
            }
          }
        }
      }
    }

    setProjectTitleInput(
      subgroupSubprojectTitle[e.currentTarget.selectedIndex - 1]
    );
    //setProjectDescriptionInput(
    //  subgroupSubprojectDescription[e.currentTarget.selectedIndex - 1]
    //);
    setProjectDescriptionReadOnly(true);
    bodyStyles.setProperty("--description-color", "LightGray");
    console.log(" subgroup selected index is ", subgroupSelectedIndex);
    setMessages(
      "Now press the 'Remove from...' button and the subgroup will be removed from the project"
    );
    //Fill in the Subproject Description: projectDescriptionInput and this comes from
    //the subgroups project which hasn't actually been created and is the detailedDescription field
  };

  const GroupSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    console.log("in group selected...");
    console.log("value from event = ", e.currentTarget.selectedIndex);
    if (e.currentTarget.selectedIndex == 0) {
      return;
    }
    setProjectDescriptionReadOnly(false);
    setProjectDescriptionInput("");
    bodyStyles.setProperty("--description-color", "White");
    setUpdateSubgroupProjectButtonDisabled(false);
    let tempIndex = e.currentTarget.selectedIndex;
    //This is breaking the convention of xxx - 1...why? Because of Copy Selection
    setGroupSelectedIndex(tempIndex);
    console.log("group profiles = ", groupProfiles);
    console.log("group ref array = ", groupRefArray);
    //console.log("group title = ", groupProfiles[tempIndex].title);
    setAffilationTitle(groupProfiles[tempIndex - 1].groupAffiliation);
    setAdministratorTitle(groupProfiles[tempIndex - 1].administratorName);
    setEmailTitle(groupProfiles[tempIndex - 1].administratorEmail);
    console.log(" group selected index is ", tempIndex);

    //Set the subproject description if a subproject exists for this subgroup

    //Anticipating that a project might pre-exist here shouldn't the procedure
    //actually go that upon selecting a project that the subgroups listbox should be filled in?
    //Yes, so make that change now before proceeding...
    //That being true, then shouldn't selecting the subgroup entry achieve the same thing?
    //And if so, do we want redundant actions, i.e. filling in the subproject description
    //Perhaps in anticipation that a group selection might be used to redundantly add an
    //existing group to the subgroups collection but assigning a different project then
    //we would want the group selection to blank the description field but the subgroup
    //selection to write out the description
    setMessages(
      "Now press the 'Copy Selection' button and the group will be copied to the subgroups selection for this project"
    );
  };

  const saveProjectChanges: (
    arg0: string,
    arg1: string
  ) => Promise<void> = async () => {
    console.log("in Save Project");

    //First, create a new project for the selected subgroup using the
    //belongsTo of the owning administrative group (currentGroup). The admin UID is that
    //of the admin of the subgroup
    //Second, update the owning group by adding the contains subgroups entry using the subgroup
    //assigned to the project just added, i.e. update the containsGroups with the subgroup
    //Third, update the owned by group entry in the group document for the subgroup
    //and point to the owning group, i.e. the administration group (currentGroup)
    //Fourth, issue a message that the project has been createed and now the user can add
    //additional subgroups, each with new subprojects
    //Fifth, reset the buttons to on entry
    //Sixth, the list boxes should be reset as they were on entry to the subgroups window

    //setProjectDescriptionInput(" ");
    //First, create a new project and save its reference id
    console.log("groupSelectedIndex - 1", groupSelectedIndex - 1);
    console.log("groupProfiles", groupProfiles);
    const firestore = getFirestore(app);
    const projectCollection = collection(firestore, "projectProfiles");
    const myDocumentData = {
      access: "public",
      administratorUID: groupProfiles[groupSelectedIndex - 1].administratorUID,
      belongsToGroup: projectOwner,
      description: projectDescriptionInput,
      detailedDescription: "To be modified by group administrator",
      projectID: "",
      projectUsers: [],
      title: projectTitleInput,
      usersUID: [],
    };

    const newDocRef = await addDoc(projectCollection, myDocumentData);
    //window.location.reload();
    console.log(" New document added with id: ", newDocRef.id);

    //Push all of the new entries into the containsGroups and containedInGroups arrays
    //so that the entire arrays may be uploaded to either the owning group or the subgroup

    console.log("subgroupSubprojectDescription = ", projectDescriptionInput);
    subgroupSubprojectDescription.push(projectDescriptionInput);
    console.log("subgroupSubprojectTitle = ", projectTitleInput);
    subgroupSubprojectTitle.push(projectTitleInput);
    console.log(
      "subgroupTitle = ",
      groupProfiles[groupSelectedIndex - 1].title
    );
    subgroupTitle.push(groupProfiles[groupSelectedIndex - 1].title);
    console.log("supergroupSuperprojectTitle = ", projectTitleInput);
    supergroupSuperprojectTitle.push(projectTitleInput);
    console.log("supergroupTitle = ", currentGroup);
    supergroupTitle.push(currentGroup);

    //Second, update the containsGroups entry for the owning group with the subgroup name
    //Owning group is currentGroup and subgroup name is referenced by the currentGroupIndex
    //Find the index to the owning group in the groupRefArray
    //Add the subgroup name and ref to the newly created subgroup's subproject in the
    //constainsGroups entry of the owning group's document

    //Get the index of the currentGroup in the group ref array
    let currentGroupIndex = 0;
    console.log(" groupRefArray = ", groupRefArray);
    console.log(" groupRefArray length = ", groupRefArray.length);
    if (groupRefArray.length > 0) {
      for (let i = 0; i < groupProfiles.length; i++) {
        console.log("ref  = ", groupRefArray[i], "for i = ", i);
        console.log("ref title = ", groupProfiles[i].title);
        if (groupProfiles[i].title === currentGroup) {
          currentGroupIndex = i;
          console.log(" found title at index i = ", i);
          console.log("groupRefArray = ", groupRefArray);
          break;
        }
      }
      console.log(" currentGroupIndex = ", currentGroupIndex);
      //Update the containsGroups entry in the owning group (currentGroup)
      let subprojectIndex = 0;
      console.log("groupRefArray", groupRefArray);
      let tempRef = groupRefArray[currentGroupIndex];
      console.log(
        "groupRefArray[currentGroupIndex]",
        groupRefArray[currentGroupIndex]
      );
      let docRef = doc(db, "Groups", tempRef);
      console.log("in save and tempRef = ", tempRef);
      //console.log("docRef from tempRef value");
      let myMap1 = new Map<string, string>([]);
      let myArray1 = [];
      let myObject1 = Object.fromEntries(myMap1);
      let myMap2 = new Map<string, string>([]);
      let myArray2 = [];
      let myObject2 = Object.fromEntries(myMap2);
      console.log("subgroupTitle.length = ", subgroupTitle.length);
      let limit = subgroupTitle.length;
      //For each entry in the subgroup listbox build the containsGroups array
      //W
      for (let i = 0; i < limit; i++) {
        console.log("i = ", i);
        console.log(
          "subgroupSubprojectDescription",
          subgroupSubprojectDescription[i]
        );
        if (projectDescriptionInput === subgroupSubprojectDescription[i]) {
          subprojectIndex = i;
        }
        //console.log("subgroupSubprojectID", subgroupSubprojectID[i]);
        console.log("subgroupSubprojectTitle", subgroupSubprojectTitle[i]);
        console.log("subgroupTitle", subgroupTitle[i]);

        myMap1 = new Map<string, string>([
          ["subgroupSubprojectDescription", subgroupSubprojectDescription[i]],
          ["subgroupSubprojectTitle", subgroupSubprojectTitle[i]],
          ["subgroupTitle", subgroupTitle[i]],
        ]);
        console.log("map1 = ", myMap1);

        myObject1 = Object.fromEntries(myMap1);
        console.log(" myObject = ", myObject1);

        myArray1.push(myObject1);
        console.log("myArray1 = ", myArray1);
        groupProfiles[currentGroupIndex].containsGroups.push(
          myObject1 as unknown as Map<string, string>
        );
      }
      tempRef = groupRefArray[currentGroupIndex];
      docRef = doc(db, "Groups", tempRef);
      updateDoc(docRef, {
        containsGroups: groupProfiles[currentGroupIndex].containsGroups,
      });

      let currentSubgroupIndex = 0;
      //console.log(
      //  " groupProfiles[groupSelectedIndex].title",
      //  groupProfiles[groupSelectedIndex].title
      //);
      for (let i = 0; i < groupProfiles.length; i++) {
        console.log("profile  = ", groupProfiles[i].title, "for i = ", i);
        //console.log("ref title from subgroup = ", subgroupTitle[i]);
        if (groupProfiles[i].title === subgroupTitle[subprojectIndex]) {
          currentSubgroupIndex = i;
          console.log(" found subgroup title at index i = ", i);
          break;
        }
      }
      //Now we have the currentGroup index into the groupRefArray
      console.log(" currentSubgroupIndex = ", currentSubgroupIndex);
      //Update the containsGroups entry in the owning group (currentGroup)

      console.log("subgroupTitle.length = ", subgroupTitle.length);
      limit = supergroupTitle.length;
      for (let i = 0; i < limit; i++) {
        console.log("i = ", i);
        myMap2 = new Map<string, string>([
          ["supergroupSuperprojectTitle", supergroupSuperprojectTitle[i]],
          ["supergroupTitle", supergroupTitle[i]],
        ]);
        console.log("map = ", myMap2);

        myObject2 = Object.fromEntries(myMap2);
        console.log(" myObject2 = ", myObject2);

        myArray2.push(myObject2);
        console.log("myArray2 = ", myArray2);

        groupProfiles[currentGroupIndex].containedInGroups.push(
          myObject2 as unknown as Map<string, string>
        );
      }
      console.log(
        "groupRefArray[currentSubgroupIndex]",
        groupRefArray[currentSubgroupIndex]
      );
      tempRef = groupRefArray[currentSubgroupIndex];
      docRef = doc(db, "Groups", tempRef);
      updateDoc(docRef, {
        containedInGroups: groupProfiles[currentGroupIndex].containedInGroups,
      });

      //Reset the environment
      setProjectDescriptionReadOnly(false);
      setProjectDescriptionInput("");
      bodyStyles.setProperty("--description-color", "White");
      setSaveButtonDisabled(true);
      setUpdateSubgroupProjectButtonDisabled(true);
      setRemoveFromProjectSubgroupButtonDisabled(true);
      //function reloadPage() {
      //  setTimeout(function)
      //  window.location.reload();
      //}

      setMessages(
        "New project created for the selected subgroup. You can now add more subgroups and projects"
      );
      console.log("before getDoc and id = ", newDocRef.id);
      console.log("before getDoc and docRef = ", newDocRef);
      if (newDocRef.id !== undefined) {
        console.log("newDocRef = ", newDocRef);
        setTimeout(UpdateProjectID, 5000, newDocRef.id, newDocRef);
      }
    }
  };

  function removeFromSubgroups() {
    //***Here we need to change to the new contains and containedIn map format
    //First, delete the project assigned to the selected subgroup
    //Second, delete the containsGroup entry for the subgroup in the currentGroup document:
    //-read the object elements into tempArray, one at a time.
    //-check each object read's info for a match with the subgroup selection's title and description
    //-when a match is found skip writing object to tempArray
    //-when all elements are read update the currentGroup's doc with the array
    //Third, delete the containedInGroup entry in the selected subgroup's document following the same
    //-steps as with "Second" above and for the selected subgroup's group document
    //and rewrite the entire entry in that document
    //Fourth, remove the selected subgroup from the subgroup listbox array with a slice
    //Fifth, set the subproject description to blank and set to write and white
    //Sixth, reset whatever buttons are required to reset and we don't know what might be set
    //Seventh, delete the entry from the listbox
    console.log("in removeFromSubgroups project ");

    //Preliminary
    //Get the index of the currentGroup in the group ref array
    let currentGroupIndex = 0;
    if (groupRefArray.length > 0) {
      for (let i = 0; i < groupProfiles.length; i++) {
        if (groupProfiles[i].title === currentGroup) {
          currentGroupIndex = i;
          console.log(" found title at index i = ", i);
          break;
        }
      }
    }
    //Get the index of the current Subgroup in the group ref array
    let currentSubgroupIndex = 0;
    if (groupRefArray.length > 0) {
      for (let i = 0; i < groupProfiles.length; i++) {
        if (groupProfiles[i].title === subgroupName[subgroupSelectedIndex]) {
          currentSubgroupIndex = i;
          console.log(" found subgroup title at index i = ", i);
          break;
        }
      }
    }

    //First, delete the project assigned to the selected subgroup
    console.log("projectRefArray", projectRefArray);
    let tempArray = [];
    //let tempRef = projectRefArray[projectTitlesIndex - 1];
    console.log("projectTitlesIndex - 1", projectTitlesIndex - 1);
    console.log("subgroupSelectedIndex", subgroupSelectedIndex);
    let tempRef = projectRefArray[subgroupSelectedIndex];
    let docRef = doc(db, "projectProfiles", tempRef);
    console.log("tempRef = ", tempRef);
    console.log("item to remove = ", projectRefArray[subgroupSelectedIndex]);
    const deleteProj = deleteProject(projectRefArray[subgroupSelectedIndex]);

    //Second, delete the containsGroup entry for the subgroup in the currentGroup document:
    //-read the object elements one at a time.
    //-check each object read's info for a match with the subgroup selection's title
    //-when a match is not found write object to tempArray
    //-when all elements are read update the currentGroup's doc with the array
    let tempTitle = "";
    let tempDescription = "";
    let found = false;
    if (groupProfiles[currentGroupIndex].containsGroups !== undefined) {
      for (
        let j = 0;
        j < groupProfiles[currentGroupIndex].containsGroups.length;
        j++
      ) {
        if (groupProfiles[currentGroupIndex].containsGroups[j] !== undefined) {
          for (const [key, value] of Object.entries(
            groupProfiles[currentGroupIndex].containsGroups[j]
          )) {
            //retrieve the key value pairs for this entry for subgroupTitle and subgroupSubprojectDescription
            if (key === "subgroupTitle") {
              tempTitle = value;
              console.log("tempTitle");
            } else if (key === "subgroupSubprojectDescription") {
              tempDescription = value;
            }
          }
          console.log("subgroupSelectedIndex = ", subgroupSelectedIndex);
          //Are we looking at the title field and does it match the selected subgroup title?
          if (tempTitle !== subgroupName[subgroupSelectedIndex]) {
            //No, so write out the entry to the temporary array
            tempArray.push(groupProfiles[currentGroupIndex].containsGroups[j]);
          }
          //No need for an else because when there is a match we will skip over it and not write it
        }
      }
    }
    //Finished creating the temp array so update the containsGroup entry
    tempRef = groupRefArray[currentGroupIndex];
    docRef = doc(db, "Groups", tempRef);
    updateDoc(docRef, {
      containsGroups: tempArray,
    });

    //Third, delete the containedInGroup entry in the selected subgroup's document
    //-read the object elements one at a time.
    //-check each object read's info for a match with the subgroup selection's title
    //-when a match is not found write object to tempArray
    //-when all elements are read update the currentGroup's doc with the array
    tempArray = [];
    tempTitle = "";
    tempDescription = "";
    found = false;
    if (groupProfiles[currentSubgroupIndex].containedInGroups !== undefined) {
      for (
        let j = 0;
        j < groupProfiles[currentSubgroupIndex].containedInGroups.length;
        j++
      ) {
        if (
          groupProfiles[currentSubgroupIndex].containedInGroups[j] !== undefined
        ) {
          for (const [key, value] of Object.entries(
            groupProfiles[currentSubgroupIndex].containedInGroups[j]
          )) {
            //retrieve the key value pairs for this entry for subgroupTitle and subgroupSubprojectDescription
            if (key === "supergroupTitle") {
              //Admin name === currentGroup === projectOwner
              tempTitle = value;
              console.log("supergroupTitle");
            } else if (key === "supergroupSuperprojectTitle") {
              //The master project of which the subgroup is assigned
              tempDescription = value;
            }
          }
          console.log("subgroupSelectedIndex = ", subgroupSelectedIndex);
          //Are we looking at the title field and does it match the selected subgroup title?
          if (
            tempTitle !== projectOwner &&
            tempDescription !== projectTitleInput
          ) {
            //No, so write out the entry to the temporary array
            tempArray.push(
              groupProfiles[currentSubgroupIndex].containedInGroups[j]
            );
          }
          //No need for an else because when there is a match we will skip over it and not write it
        }
      }
    }
    //Finished creating the temp array so update the containsGroup entry
    tempRef = groupRefArray[currentSubgroupIndex];
    docRef = doc(db, "Groups", tempRef);
    updateDoc(docRef, {
      containedInGroups: tempArray,
    });

    //Fourth, remove the selected subgroup from the subgroup listbox
    console.log("subgroupSelectedIndex = ", subgroupSelectedIndex);
    console.log(
      " subgroup name to remove = ",
      subgroupName[subgroupSelectedIndex]
    );

    let tempSubgroup = subgroupName;

    tempSubgroup.splice(subgroupSelectedIndex, 1);

    setSubgroupName(tempSubgroup);
    console.log(" all subgroups after splice = ", subgroupName);

    //Fifth, set the subproject description to blank
    setProjectDescriptionInput("");

    //Sixth, reset whatever buttons are required to reset and we don't know what might be set
    setMessages("Subgroups for this project updated...");
    setProjectDescriptionReadOnly(false);
    setProjectDescriptionInput("");
    bodyStyles.setProperty("--description-color", "White");

    //Seventh, delete the entry from the listbox
    //subgroupName.splice(subgroupSelectedIndex, 1);
  }

  function updateSubgroupProject() {
    //Adds selected group to the subgroup listbox

    console.log("updateSubgroupProject entered");
    console.log("group names array = ", groupName);
    //Note that as of 24/08/2024 at 10:28 am the groupSelectedIndex is off by 1 smaller
    //which makes the groupSelectedIndex -1 2 smaller then what is needed
    console.log(
      " the index to which group to add from groupSelectedIndex - 1 = ",
      groupSelectedIndex - 1
    );

    //Take the selected group from Groups and add to subgroups listbox ok
    subgroupName.push(groupProfiles[groupSelectedIndex - 1].title);
    console.log(" subgroups after push = ", subgroupName);

    setMessages(
      "Now edit the subproject description for the project of the subgroup; or remove the subgroup selection."
    );
    setUpdateSubgroupProjectButtonDisabled(true);
    setRemoveFromProjectSubgroupButtonDisabled(false);
    setProjectDescriptionReadOnly(false);
    setProjectDescriptionInput("");
    bodyStyles.setProperty("--description-color", "White");
  }

  const ProjectSelected = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //When a project is selected we must:
    //1. Retrieve the project's details and fill in the page
    //2. Retrieve the userProject entries and fill them in and note that we need to pop
    //all the existing entries first, i.e. for length >= 1
    //3. Reset buttons
    //4. Set the get select to true
    //5. Set the new projectSelectedIndex (projectTitlesIndex)
    //6. Display a message to the user

    //***On entry we need to clear out the subgroup list box before adding new entries
    //***On entry we don't need to set admin text areas attributes to grey or we need to
    //   add a css entry just for admin

    const tempIndex = e.currentTarget.selectedIndex;

    if (tempIndex == 0) {
      return;
    }
    setProjectTitlesIndex(tempIndex);
    console.log("ProjectSelected entered");
    setMessages(
      "Now, select a group to add to the subgroups for this project or select and remove a subgroup"
    );
    setGetSelect(true);
    //setProjectTitlesIndex(e.currentTarget.selectedIndex);
    console.log("tempIndex -1 = ", tempIndex - 1);

    document.getElementById("input_Title").setAttribute("readOnly", "true");
    bodyStyles.setProperty("--text-color", "LightGray");
    setProjectTitleInput(projectTitles[tempIndex - 1]);
    setProjectDescriptionInput("");
    setProjectDescriptionReadOnly(false);
    setProjectDescriptionInput("");
    bodyStyles.setProperty("--description-color", "White");

    for (let i = 0; i < groupProfiles.length; i++) {
      groupName[i] = groupProfiles[i].title;
    }
    console.log("groupNames are ", groupName);
    console.log(
      " project users length = ",
      projectProfiles[tempIndex - 1].projectUsers.length
    );
    let currentGroupIndex = 0;
    //Get the owning group
    for (let i = 0; i < groupProfiles.length; i++) {
      console.log("ref  = ", groupRefArray[i], "for i = ", i);
      console.log("ref title = ", groupProfiles[i].title);
      if (groupProfiles[i].title === currentGroup) {
        currentGroupIndex = i;
        console.log(" found title at index i = ", i);
        console.log("groupRefArray = ", groupRefArray);
        break;
      }
    }
    console.log(
      "groupProfiles[currentGroupIndex]",
      groupProfiles[currentGroupIndex]
    );
    //Get the owning group's containsGroups entries
    console.log(
      "groupProfiles[currentGroupIndex].containsGroups",
      groupProfiles[currentGroupIndex].containsGroups
    );
    console.log("subgroupName before ", subgroupName);
    //let tempSubgroup = [];
    //setSubgroupName(tempSubgroup);
    for (let i = 0; i < subgroupName.length; i++) {
      subgroupName.pop();
    }
    console.log("subgroupName after ", subgroupName);
    //Iterate through all of the containsGroups values that exist (if any)
    if (groupProfiles[currentGroupIndex].containsGroups !== undefined) {
      for (
        let j = 0;
        j < groupProfiles[currentGroupIndex].containsGroups.length;
        j++
      ) {
        if (groupProfiles[currentGroupIndex].containsGroups[j] !== undefined) {
          for (const [key, value] of Object.entries(
            groupProfiles[currentGroupIndex].containsGroups[j]
          )) {
            if (key === "subgroupTitle") {
              console.log("subgroupTitle = ", value);
              subgroupName.push(value as string);
              console.log("subgroupName with additions ", subgroupName);
              setRemoveFromProjectSubgroupButtonDisabled(false);
            }
          }
        }
      }
    }
  };
  //currentGroup and all of its projects to fetch the project doc id
  //console.log("currentGroup = ", currentGroup);
  //console.log("tempUser = ", tempUser);
  projectRefArray = [];
  projectTitles = [];
  projectDescriptions = [];
  projectDetailedDescriptions = [];
  projectID = [];

  const q0 = query(
    collection(db, "projectProfiles"),
    where("belongsToGroup", "==", currentGroup),
    orderBy("title")
  );
  useEffect(
    () =>
      onSnapshot(q0, (snapshot) => {
        setProjectProfiles(
          snapshot.docs.map((doc) => {
            //console.log("doc.id = ", doc.id);
            projectRefArray.push(doc.id);

            //console.log(" projectRefArray  ", projectRefArray);
            //console.log(" doc data () ", doc.data());

            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  console.log("projectRefArray ", projectRefArray);
  for (let i = 0; i < projectProfiles.length; i++) {
    projectTitles.push(projectProfiles[i].title);
    projectDescriptions.push(projectProfiles[i].description);
    projectDetailedDescriptions.push(projectProfiles[i].detailedDescription);
    //if (projectProfiles[i].projectID)
    projectRefArray.push(projectProfiles[i].projectID);
  }
  //groupProfiles
  groupRefArray = [];
  affiliation = [];
  administrator = [];
  email = [];
  const q2 = query(collection(db, "Groups"));
  useEffect(
    () =>
      onSnapshot(q2, (snapshot) => {
        setGroupProfiles(
          snapshot.docs.map((doc) => {
            //console.log("doc.id = ", doc.id);
            groupRefArray.push(doc.id);
            //console.log("groupRefArray", groupRefArray);
            //console.log(" doc data () ", doc.data());

            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  for (let i = 0; i < groupProfiles.length; i++) {
    affiliation.push(groupProfiles[i].groupAffiliation);
    administrator.push(groupProfiles[i].administratorName);
    email.push(groupProfiles[i].administratorEmail);
    groupRefArray.push(groupProfiles[i].groupID);

    console.log(" groupProfiles[i].groupID  ", groupProfiles[i].groupID);

    console.log(" groupRefArray  ", groupRefArray);
  }

  return (
    <div>
      <>
        <div>
          <div className={styles.wrapper}>
            <div className={styles.top}>
              <label
                style={{
                  marginLeft: 0,
                  fontWeight: 550,
                  fontSize: 25,
                  marginTop: 0,
                }}
              >
                Administration - add subgroups and subprojects to a
                collaborative project
              </label>
            </div>
            <br />
            <div>
              <div className={styles.aimLabel}>
                <label
                  className={styles.forh3}
                  style={{ marginLeft: 8, fontWeight: 550, fontSize: 20 }}
                >
                  Instructions
                </label>
                <textarea
                  id="input_Title"
                  className={styles.messageText}
                  rows={5}
                  cols={70}
                  readOnly
                  value={messages}
                  style={{
                    paddingLeft: 3,
                    marginLeft: 99,
                    width: 540,
                    height: 80,
                    marginTop: 3,
                  }}
                />
              </div>
              <br />
              <div>
                <label
                  className={styles.forh3}
                  style={{ marginLeft: 25, fontWeight: 550, fontSize: 20 }}
                >
                  Group Administrator
                </label>
                <textarea
                  id="input_Title"
                  className={styles.messageTextTitle}
                  rows={3}
                  cols={78}
                  readOnly
                  style={{
                    paddingLeft: 3,
                    marginLeft: 20,
                    width: 285,
                    height: 17,
                  }}
                  defaultValue={projectOwner}
                  onChange={(e) => {
                    setProjectTitleInput(e.target.value);
                    if (getSelect) {
                      setSaveButtonDisabled(false);
                    }
                  }}
                />
              </div>
              <br />
              <div>
                <label
                  className={styles.forh3}
                  style={{ marginLeft: 25, fontWeight: 550, fontSize: 20 }}
                >
                  The Project
                </label>
                <select
                  name="Project List"
                  id="project-select"
                  onChange={ProjectSelected}
                  style={{ marginLeft: 105 }}
                >
                  <option value="">-- Project Selection --</option>
                  {projectTitles.map((projectTitles, key) => (
                    <option key={key} value={projectTitles}>
                      {projectTitles}
                    </option>
                  ))}
                </select>

                <button
                  id="saveProjectButtonID"
                  className={styles.buttonClass}
                  style={{ marginLeft: 35, marginTop: -30 }}
                  disabled={saveButtonDisabled}
                  onClick={() =>
                    saveProjectChanges(
                      projectTitleInput,
                      projectDescriptionInput
                    )
                  }
                >
                  Save
                </button>

                <button
                  id="closeButtonID"
                  className={styles.buttonClass}
                  style={{ marginLeft: 20, marginTop: -80 }}
                  onClick={() => history.back()}
                >
                  Return
                </button>
              </div>
            </div>
            <br />
            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30, marginTop: 5 }}>
                Subproject Title
              </label>
              <textarea
                id="input_Title"
                className={styles.messageTextTitle}
                rows={3}
                cols={90}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 79,
                  width: 540,
                  height: 17,
                  marginTop: 3,
                }}
                defaultValue={projectTitleInput}
              />
              <br />
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30 }}>Subproject Description</label>
              <textarea
                id="input_Description"
                className={styles.descriptionTextTitle}
                rows={3}
                cols={80}
                readOnly={projectDescriptionReadOnly}
                style={{
                  paddingLeft: 3,
                  marginLeft: 30,
                  width: 540,
                  height: 50,
                }}
                value={projectDescriptionInput}
                onChange={(e) => {
                  setProjectDescriptionInput(e.target.value);
                  if (getSelect) {
                    setSaveButtonDisabled(false);
                    setMessages(
                      "Press the 'Save' button to create the new subproject for this subgroup."
                    );
                  }
                }}
              />
            </div>
            <br />
            <div>
              <label
                className={styles.forh3}
                style={{
                  marginLeft: 50,
                  fontWeight: 500,
                  fontSize: 18,
                  marginRight: 10,
                  marginTop: 5,
                }}
              >
                Groups
              </label>
              <select
                name="Group List"
                id="group-select"
                size={groupName.length + 1}
                style={{ marginLeft: 120, padding: 3 }}
                onChange={GroupSelected}
              >
                <option value="">-- Group Selection --</option>
                {groupName.map((groupName, key) => (
                  <option key={key} value={groupName}>
                    {groupName}
                  </option>
                ))}
              </select>
              <button
                disabled={updateSubgroupProjectButtonDisabled}
                id="updateSubgroupProjectButtonID"
                className={styles.userButtons}
                style={{
                  marginLeft: 0,
                  height: 40,
                  marginBottom: -5,
                  width: 140,
                }}
                onClick={() => updateSubgroupProject()}
              >
                Copy Selection to Subgroups
              </button>
              <br />
              <br />
              <div>
                <label style={{ marginLeft: 235, marginTop: 5 }}>
                  Administrator
                </label>
                <textarea
                  id="input_Title"
                  className={styles.messageTextTitle}
                  rows={3}
                  cols={80}
                  style={{
                    paddingLeft: 3,
                    marginLeft: 65,
                    width: 200,
                    height: 17,
                    marginTop: 3,
                  }}
                  defaultValue={administratorTitle}
                />
              </div>
              <br />
              <div>
                <label style={{ marginLeft: 235, marginTop: 5 }}>
                  Administrator Email
                </label>
                <textarea
                  id="input_Title"
                  className={styles.messageTextTitle}
                  rows={3}
                  cols={80}
                  style={{
                    paddingLeft: 3,
                    marginLeft: 20,
                    width: 200,
                    height: 17,
                    marginTop: 3,
                  }}
                  defaultValue={emailTitle}
                />
              </div>
              <br />
              <div>
                <label style={{ marginLeft: 235, marginTop: 5 }}>
                  Affiliation
                </label>
                <textarea
                  id="input_Title"
                  className={styles.messageTextTitle}
                  rows={3}
                  cols={80}
                  style={{
                    paddingLeft: 3,
                    marginLeft: 93,
                    width: 385,
                    height: 17,
                    marginTop: 3,
                  }}
                  defaultValue={affiliationTitle}
                />
              </div>
              <br />
              <div>
                <label
                  className={styles.forh3}
                  style={{
                    marginLeft: 50,
                    fontWeight: 500,
                    fontSize: 18,
                    marginRight: 10,
                    marginTop: 5,
                  }}
                >
                  Subgroups
                </label>
                <select
                  name="Subgroup List"
                  id="subgroup-select"
                  size={subgroupName.length + 1}
                  style={{ marginLeft: 85, padding: 3 }}
                  onChange={SubgroupSelected}
                >
                  <option value="">-- Subgroup Selection --</option>
                  {subgroupName.map((subgroupName, key) => (
                    <option key={key} value={subgroupName}>
                      {subgroupName}
                    </option>
                  ))}
                </select>
                <button
                  disabled={removeFromProjectSubroupButtonDisabled}
                  id="removeFromProjectSubgroupButtonID"
                  className={styles.userButtons}
                  style={{ marginLeft: 0, height: 40 }}
                  onClick={() => removeFromSubgroups()}
                >
                  Remove from Subgroups
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default SubgroupSelect;
